/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ArticleType {
  Authored = 'Authored',
  Link = 'Link',
  Knowledge = 'Knowledge'
}
